import { useEffect, useState, useCallback } from 'react'
import debounce from 'lodash/debounce';
import { useParams } from 'react-router-dom'
import AnimatedPage from '../../components/AnimatedPage'
import Button from '../../components/common/Button'
import { postRequest, showMessage } from '../../config'
import PromoCodeInput from '../../components/modals/SubscriptionPaymentConfirm/PromoCodeInput'
import ModalWrapper from '../../components/common/Modal/ModalWrapper'
import { useDispatch } from 'react-redux'
import { toggleModal } from '../../reducers/modalReducer'
import { packages } from "../../env";

const DiscountCodeStep = ({
    promoCode,
    setPromoCode,
    isValidCoupon,
    isCheckingCoupon,
    handlePurchase,
    loading,
    dispatch
}) => {
    const handleClose = () => {
        dispatch(toggleModal({ open: '' }));
    };

    return (
        <>
            <ModalWrapper onCloseHandler={handleClose} modalType='subscriptionPaymentConfirmClientCompany'>
                <div className='df fdc jcc aic'>
                    <img
                        style={{ width: '93px', height: '75px' }}
                        src={require('../../../images/checklist-logo.webp')}
                        alt='logoDiligentsia'
                    />

                    <h3 className='c15 tac mt1rem fw400 fs22px'>Please confirm you wish to purchase this pro subscription</h3>
                    <p className='c15 op60 fs10px my0-5rem tac fw500'>This is an monthly charge</p>
                    <PromoCodeInput
                        promoCode={promoCode}
                        setPromoCode={(e) => {
                            setPromoCode(e)
                            if (!e || (e && e === "")) {
                                setPromoCodeData(null)
                            }
                        }}
                        isValid={isValidCoupon}
                        isChecking={isCheckingCoupon}
                    />
                    <div className='df fdc aic jcc w100 mt3rem mb1rem' style={{ width: '280px' }}>
                        <Button
                            onClick={handlePurchase}
                            btnType="warning"
                            customClassName='w100'
                            text="Continue to Purchase"
                            disabled={
                                loading ||
                                isCheckingCoupon ||
                                (!isValidCoupon && promoCode !== '')
                            }
                        />
                    </div>
                </div>
            </ModalWrapper>
        </>
    );
};

const IndirectCompanyBillingPage = () => {
    const dispatch = useDispatch();
    const defaultPromoCodeData = {
        advisor: {
            code: 'ADVISOR20',
        },
        investor: {
            code: 'INVESTOR20',
        }
    }
    const { id, subscription, role } = useParams()
    console.log(defaultPromoCodeData[role]?.code, role)
    const [promoCode, setPromoCode] = useState(defaultPromoCodeData[role]?.code || '');
    const [loading, setLoading] = useState(false);
    const [promoCodeData, setPromoCodeData] = useState(null);
    const [amount, setAmount] = useState({
        totalAmount: 83.25,
        sellingPrice: 66.60
    })
    const [isValidCoupon, setIsValidCoupon] = useState(true);
    const [isCheckingCoupon, setIsCheckingCoupon] = useState(false);

    const checkCoupon = useCallback(
        debounce(async (code) => {
            if (!code) {
                setIsValidCoupon(true);
                setIsCheckingCoupon(false);
                return;
            }

            try {

                const response = await postRequest(`/payment/checkCoupon/${code}`, { amount: packages['Pro']?.price });
                setPromoCodeData(response?.body);
                setIsValidCoupon(response?.code === 200);
            } catch (error) {
                console.log('Error checking coupon:', error);
                setIsValidCoupon(false);
            } finally {
                setIsCheckingCoupon(false);
            }
        }, 1000),
        []
    );

    useEffect(() => {
        setIsCheckingCoupon(true);
        console.log('Checking coupon:', promoCode);
        checkCoupon(promoCode);
    }, [promoCode, checkCoupon]);

    useEffect(() => {
        if (promoCodeData) {
            if (promoCodeData?.discountType === 'percentage') {
                const discountAmount = (amount.totalAmount / 100) * (promoCodeData?.discountValue || 0)
                if (amount.totalAmount >= discountAmount) {
                    setAmount((prev) => ({
                        ...prev,
                        sellingPrice: Number(prev.totalAmount - discountAmount).toFixed(2)
                    }));
                } else {
                    showMessage('Invalid coupon code!')
                }
            } else {
                setAmount((prev) => ({
                    ...prev,
                    sellingPrice: Number(prev.totalAmount - (promoCodeData?.discountValue || 0)).toFixed(2)
                }));
            }
        }
    }, [promoCodeData])


    const capitalizeWords = (text) =>
        text.split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        ).join(' ')

    const handleBuySubscription = async () => {
        let data = {
            endPoint: `/payment/upgrade-subscription/${id}`,
            payload: {
                packageName: capitalizeWords(subscription),
                ...((role && promoCode && promoCode !== "" && promoCodeData) && { promoCode: promoCodeData?.stripePromotionCodeId })
            }
        };

        if (promoCodeData && promoCodeData?.discountType === "percentage" && promoCodeData?.discountValue === 100) {
            data.endPoint = `/payment/subscriptionWithAccessCode/${id}`;
            data.payload = {
                ...data.payload,
                ...((role && promoCode && promoCode !== "" && promoCodeData) && { promoCode: promoCodeData?.code })
            }
        }

        setLoading(true);
        const response = await postRequest(`${data?.endPoint}`, data?.payload);
        if (response?.code === 200) {
            if (response?.body?.url) {
                window.location.href = response.body?.url;
            } else {
                window.location.href = `/company/${id}`;
            }
        }
        setLoading(false);
    }

    return (
        <>
            <AnimatedPage>
                <div className="poppins-font-style bg1 pricing-indirectCompany-billing-page bg72">
                    <div className='df aic jcc h100' style={{ minHeight: '100vh' }}>
                        <div className='pl5rem c15' style={{ width: '65%' }} >
                            <h1 style={{ width: '550px' }}>
                                Your {capitalizeWords(role)} Has Negotiated You A Discount!
                            </h1>
                            <div className='pr shadow bg1 br10px py1rem px2rem mt2rem' style={{ width: '480px' }} >
                                <p
                                    style={{
                                        backgroundImage: `url(${require('../../../images/pricing-page/discountVector.png')})`,
                                        minHeight: Number(promoCodeData?.discountValue) === 100 ? '82px' : '72px',
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'right center',
                                        right: '30px',
                                        top: '0px',
                                        padding: '8px 6px 9px',
                                        fontSize: '1rem',
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}
                                    className='c1 fs1rem fw600 tac pa'>
                                    <span>{promoCodeData?.discountValue || 20}{promoCodeData && promoCodeData?.discountType !== "percentage" ? '£' : "%"}</span>
                                    <span>Off</span>
                                </p>

                                <p className='fw600'>Portfolio PRO</p>
                                <p style={{ textDecoration: 'line-through' }} className='c73 fw500 fs1-25rem'>£{amount?.totalAmount} </p>
                                <p className="c15 fw500 tal">
                                    <span className="c3 fs2rem fw600">£{amount?.sellingPrice}</span>
                                    <span>/month*</span>
                                </p>
                                <p className='c71 fw400 mt1rem fs12px'>*= only available via {capitalizeWords(role)}.. Billed annually </p>
                            </div>

                            <p className='fw500 mt4rem' style={{ color: '#000' }}>Your {capitalizeWords(role)} discount code :
                                <span className='c4'> {defaultPromoCodeData[role]?.code}</span>
                            </p>
                            <p className='c15 op60 fs14px'>Insert code on next screen</p>

                            <Button
                                onClick={() => { dispatch(toggleModal({ open: 'subscriptionPaymentConfirmClientCompany' })) }}
                                customClassName='mt3rem'
                                btnType='warning'
                                text={'Buy Now'}
                                style={{
                                    width: '250px'
                                }}
                            />
                        </div>
                        <div
                            style={{
                                backgroundImage: `url(${require('../../../images/billing/hands.png')})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                width: '40%',
                                minHeight: '100vh'
                            }}
                            className='pr'
                        >
                            <img src={require('../../../images/billing/portfolioPro.png')} atl='portfolioPro.png' className='pa' style={{ maxWidth: '150px', top: '20px', right: '40px' }} />

                        </div>
                    </div>
                </div>

                <DiscountCodeStep
                    promoCode={promoCode}
                    setPromoCode={setPromoCode}
                    isValidCoupon={isValidCoupon}
                    isCheckingCoupon={isCheckingCoupon}
                    handlePurchase={handleBuySubscription}
                    loading={loading}
                    dispatch={dispatch}
                />
            </AnimatedPage >

        </>
    )
}

export default IndirectCompanyBillingPage